export class SupplierFilterForm {
  code: string;
  name: string;

  pageSize = 10;
  pageOffset = 0;
}
